import { sendGoogleAnalyticsEvents } from '@elfsight/lib-google-analytics';
import type { GoogleAnalytics } from '../../types';

type SendGoogleAnalyticsTrackStartedPlayingEventsArgs = {
  googleAnalytics: GoogleAnalytics[];
  widgetId?: string;
  artist?: string;
  title?: string;
};

export function sendGoogleAnalyticsTrackStartedPlayingEvents({
  googleAnalytics,
  widgetId = '',
  artist = '',
  title = ''
}: SendGoogleAnalyticsTrackStartedPlayingEventsArgs) {
  const valueMapping = {
    widgetId,
    trackName: title,
    artistName: artist
  };

  sendGoogleAnalyticsEvents({
    googleAnalyticsEvents: googleAnalytics,
    eventType: 'trackStartedPlaying',
    valueMapping
  });
}
